import { AxiosRequestConfig, AxiosResponse } from "axios";
import { getAxiosInstances } from "../../../../utils/AppUtils";
import AxiosActions from "../../AxiosActions";

export const graphQlRequest = <T = any>(query: any, spinner: boolean, config: AxiosRequestConfig = {}): Promise<AxiosResponse<T>> => {
    return AxiosActions.post(getAxiosInstances()?.graphqlInstance, `graphql`, query, { ...config }, spinner, false);
};
